/**
 * Recently opened docs (per workspace, local). Used when we add a recents
 * surface later — recording is cheap and already wired on open.
 */

const recentKey = (workspaceId) =>
  `fokus:docs-recent:${workspaceId || 'personal'}`;

const MAX_RECENT = 12;

const safeParse = (raw, fallback) => {
  try {
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v : fallback;
  } catch {
    return fallback;
  }
};

/** @returns {Array<{ id: string, at: string }>} */
export function loadDocsRecent(workspaceId) {
  if (typeof localStorage === 'undefined') return [];
  return safeParse(localStorage.getItem(recentKey(workspaceId)), []);
}

export function recordDocOpen(workspaceId, docId) {
  if (!docId || typeof localStorage === 'undefined') return;
  const prev = loadDocsRecent(workspaceId).filter((r) => r.id !== docId);
  const next = [{ id: docId, at: new Date().toISOString() }, ...prev].slice(0, MAX_RECENT);
  localStorage.setItem(recentKey(workspaceId), JSON.stringify(next));
  return next;
}
